import { Form, Mentions } from 'antd'
import React, { useMemo } from 'react'
import { getFiles } from '../../../../services/assistant'
import { InputSearch } from '../../../input-search'

export default function Search({ fieldName, parameters, assistantID }) {
  const available = useMemo(() => {
    const props = parameters?.properties
    if (!props) return []
    const arr = Array.isArray(props)
      ? props
      : Object.entries(props).map(([name, schema]) => ({ name, ...schema }))
    return arr.map(({ name }) => ({ label: name, value: name }))
  }, [parameters])

  return (
    <>
      <Form.Item
        label={'Pesquisar por'}
        rules={[
          {
            required: true,
            message: 'É preciso preencher algum texto para pesquisa',
          },
        ]}
        name={[fieldName, 'action', 'data', 'searchText']}
      >
        <Mentions
          placeholder={'Parametro para pesquisa'}
          help={'Use $ para usar parametros do gatilho'}
          prefix={'$'}
          options={available}
        />
      </Form.Item>
      <Form.Item
        label={'Filtrar por documento'}
        name={[fieldName, 'action', 'data', 'assistantFileID']}
      >
        <InputSearch
          searchField={'title'}
          getCallback={(rest) =>
            getFiles({ assistantID, status: 'DONE', ...rest })
          }
        />
      </Form.Item>
    </>
  )
}
